import _objectWithoutProperties from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { reportMetricsV2 } from '@engage/video';
import { apiClient } from '@webtv/data-fetch';
import { captureException } from '@webtv/error-reporting-v2';
export var WATCH_TIME_STORAGE_KEY = 'WatchTimePendingBatches';
export function getPersistedMetricBatches() {
  var _localStorage$getItem;

  var persistedMetricsJson = (_localStorage$getItem = localStorage.getItem(WATCH_TIME_STORAGE_KEY)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : '';
  if (!persistedMetricsJson.length) return {};

  try {
    var persistedMetrics = JSON.parse(persistedMetricsJson);
    return persistedMetrics;
  } catch (e) {
    captureException(e);
    return {};
  }
}

function sendPersistedMetricBatches(_x, _x2) {
  return _sendPersistedMetricBatches.apply(this, arguments);
}

function _sendPersistedMetricBatches() {
  _sendPersistedMetricBatches = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(workoutId, batchesToSend) {
    var _getPersistedMetricBa, completedBatch, rest;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return reportMetricsV2(apiClient, {
              workoutId: workoutId,
              batches: batchesToSend
            });

          case 3:
            _context.next = 8;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            captureException(_context.t0);

          case 8:
            // Remove batches even if the request has failed to prevent endless failed requests
            _getPersistedMetricBa = getPersistedMetricBatches(), completedBatch = _getPersistedMetricBa[workoutId], rest = _objectWithoutProperties(_getPersistedMetricBa, [workoutId].map(_toPropertyKey));
            localStorage.setItem(WATCH_TIME_STORAGE_KEY, JSON.stringify(rest));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  }));
  return _sendPersistedMetricBatches.apply(this, arguments);
}

export var usePersistedWatchTimeMetrics = function usePersistedWatchTimeMetrics() {
  var router = useRouter();
  useEffect(function () {
    var persistedMetrics = getPersistedMetricBatches();

    for (var workoutId in persistedMetrics) {
      sendPersistedMetricBatches(workoutId, persistedMetrics[workoutId]);
    }
  }, [router.route]);
};